import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import { ORDER_REQUIRED_FIELDS, SALES_REP_FILTER_RULES } from '../shared';

/**
 * Today's Orders list configuration
 * Orders created today
 */
export const todaysOrdersList: ListBuilderList = {
	id: 'todays-orders',
	cacheTTL: 600000,
	name: "Today's Orders",
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createStandardOrderColumns(),
	description: 'Orders created today',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
